import { Module } from 'vuex';
import { RootState } from '../types';
import { getters } from './_getters';
import { actions } from './_actions';
import { mutations } from './_mutations';
import {AxiosState} from './types';

export const state: AxiosState = {
    cancels: {}
};

const namespaced: boolean = true;

export const Axios: Module<AxiosState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
